import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Info, RefreshCw, Settings, SlidersHorizontal, X } from 'lucide-react';
import { indicatorDict, mockStudents } from '../data/mockData';

// 加分项审核页面
// 页面结构：条件筛选卡片 + 结果卡片（审核阶段 Tab + 表格）+ 右侧详情/审核抽屉
export default function BonusAuditPage() {
  // ================= 页面状态 =================
  const [activeTab, setActiveTab] = useState('全部');
  const [drawerConfig, setDrawerConfig] = useState({
    isOpen: false,
    mode: 'detail',
    record: null,
  });

  // ================= Tab 配置 =================
  const tabs = [
    '全部',
    '评议小组审核',
    '辅导员审核',
    '已通过',
    '不通过',
    '退回',
  ];

  // ================= 表格数据 =================
  const bonusAuditList = [
    {
      id: 1,
      name: '陈红',
      studentId: '2102001',
      academicYear: '2025-2026',
      semester: '第一学期',
      className: '计算机1班',
      major: '软件工程',
      college: '计算机学院',
      ownerUnit: '计算机学院',
      grade: '2021级',
      studentType: '本科生',
      applyTime: '2026-05-15 13:33:44',
      auditStatus: '评议小组审核',
      projectName: '参与“青年大学习”等线上主题团课',
      materialName: '青年大学习截图.pdf',
      selectedCount: 2,
      score: 2,
    },
    {
      id: 2,
      name: '林峰',
      studentId: '2102002',
      academicYear: '2025-2026',
      semester: '第一学期',
      className: '计算机2班',
      major: '软件工程',
      college: '计算机学院',
      ownerUnit: '计算机学院',
      grade: '2021级',
      studentType: '本科生',
      applyTime: '2026-05-15 13:37:09',
      auditStatus: '辅导员审核',
      projectName: '参加校(院)级青年马克思主义学校等培训班并结业',
      materialName: '结业证明.pdf',
      selectedCount: 1,
      score: 2,
    },
  ];

  const openDrawer = (mode, record) => {
    setDrawerConfig({
      isOpen: true,
      mode,
      record,
    });
  };

  const closeDrawer = () => {
    setDrawerConfig({
      isOpen: false,
      mode: 'detail',
      record: null,
    });
  };

  return (
    <div className="animate-fade-in space-y-4">
      {/* 条件筛选卡片：仅保留本次要求的筛选条件 */}
      <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
        <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 gap-x-8 gap-y-6">
          <FilterSelect label="学年" />
          <FilterSelect label="学期" />
          <FilterSelect label="学院/专业/班级" />
          <FilterSelect label="测评指标所属单位" />
          <FilterSelect label="年级" />
          <FilterSelect label="学生类别" />
          <FilterInput label="姓名" placeholder="请输入姓名" />
          <FilterInput label="学号" placeholder="请输入学号" />
        </div>

        {/* 查询按钮区 */}
        <div className="flex justify-end items-center gap-3 mt-6">
          <button className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50">
            重置
          </button>
          <button className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]">
            查询
          </button>
          <button className="text-[#1890ff] text-sm flex items-center gap-1">
            收起
            <ChevronUp size={15} />
          </button>
        </div>
      </div>

      {/* 结果卡片：加分项审核列表 */}
      <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
        {/* 结果卡片 Tab：切换不同审核阶段 */}
        <div className="flex items-center gap-8 border-b border-gray-100 mb-5">
          {tabs.map(tab => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`pb-4 text-sm font-medium ${activeTab === tab ? 'text-[#1890ff] border-b-2 border-[#1890ff]' : 'text-gray-900 hover:text-[#1890ff]'}`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* 表格上方工具区：审核中 Tab 展示批量审核按钮 */}
        <div className="flex justify-between items-center mb-4">
          {['评议小组审核', '辅导员审核'].includes(activeTab) ? (
            <div className="flex gap-3">
              <button className="px-4 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9] transition-colors">
                批量审核通过
              </button>
              <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50 transition-colors">
                批量退回上一步
              </button>
              <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50 transition-colors">
                批量退回申请人
              </button>
            </div>
          ) : (
            <div />
          )}

          <TableToolbar />
        </div>

        {/* 加分项审核表格 */}
        <div className="overflow-x-auto border border-gray-200 rounded">
          <table className="w-full text-left border-collapse text-[13px] text-gray-700 whitespace-nowrap min-w-max">
            <thead>
              <tr className="bg-[#fafafa] border-b border-gray-200">
                {['评议小组审核', '辅导员审核'].includes(activeTab) && (
                  <th className="py-3 px-4 w-10">
                    <input type="checkbox" className="rounded border-gray-300" />
                  </th>
                )}
                <TableHead>序号</TableHead>
                <TableHead>姓名</TableHead>
                <TableHead>学号</TableHead>
                <TableHead>学年</TableHead>
                <TableHead>学期</TableHead>
                <TableHead>班级</TableHead>
                <TableHead>专业</TableHead>
                <TableHead>学院</TableHead>
                <TableHead>测评指标所属单位</TableHead>
                <TableHead>申请时间</TableHead>
                <th className="py-3 px-4 font-medium text-gray-800 sticky right-0 bg-[#fafafa] z-10 border-l border-gray-200 shadow-[-8px_0_12px_rgba(0,0,0,0.05)]">
                  操作
                </th>
              </tr>
            </thead>
            <tbody>
              {bonusAuditList.map((row, index) => {
                const isReviewTab = activeTab === '评议小组审核';

                return (
                  <tr
                    key={row.id}
                    className="border-b border-gray-100 hover:bg-[#f8f9fa] group"
                  >
                    {['评议小组审核', '辅导员审核'].includes(activeTab) && (
                      <td className="py-3 px-4">
                        <input type="checkbox" className="rounded border-gray-300" />
                      </td>
                    )}
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.studentId}</TableCell>
                    <TableCell>{row.academicYear}</TableCell>
                    <TableCell>{row.semester}</TableCell>
                    <TableCell>{row.className}</TableCell>
                    <TableCell>{row.major}</TableCell>
                    <TableCell>{row.college}</TableCell>
                    <TableCell>{row.ownerUnit}</TableCell>
                    <TableCell>{row.applyTime}</TableCell>
                    <td className="py-3 px-4 sticky right-0 bg-white group-hover:bg-[#f8f9fa] z-10 border-l border-gray-100 shadow-[-8px_0_12px_rgba(0,0,0,0.05)]">
                      <button
                        onClick={() => openDrawer(isReviewTab ? 'audit' : 'detail', row)}
                        className="text-[#1890ff] hover:underline"
                      >
                        {isReviewTab ? '审核' : '详情'}
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* 分页区 */}
        <SimplePagination total={bonusAuditList.length} />
      </div>

      {/* 右侧抽屉：加分项详情/审核 */}
      {drawerConfig.isOpen && (
        <BonusAuditDrawer
          mode={drawerConfig.mode}
          record={drawerConfig.record}
          onClose={closeDrawer}
        />
      )}
    </div>
  );
}

// 加分项详情/审核抽屉
function BonusAuditDrawer({ mode, record, onClose }) {
  const student = mockStudents.find(item => item.studentId === record.studentId) || mockStudents[0];
  const isAudit = mode === 'audit';

  return (
    <div className="fixed inset-0 z-[60] flex justify-end transition-opacity duration-300 bg-black/40 opacity-100 visible">
      <div className="absolute inset-0" onClick={onClose} />
      <div className="relative w-[96vw] max-w-[1550px] bg-[#eeeeee] h-full shadow-[-10px_0_30px_rgba(0,0,0,0.15)] flex flex-col transform transition-transform duration-300 ease-out translate-x-0">
        {/* 抽屉标题栏 */}
        <div className="h-[60px] px-6 border-b border-gray-200 flex justify-between items-center bg-white shrink-0 z-20">
          <h2 className="text-[17px] font-bold text-gray-800 flex items-center">
            <div className="w-1 h-4 bg-[#1890ff] rounded-sm mr-2" />
            {isAudit ? '加分项审核' : '加分项申请'} - {record.name}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full text-gray-400 hover:text-gray-600"
          >
            <X size={20} />
          </button>
        </div>

        {/* 抽屉内容 */}
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {/* 卡片1：学生基本信息 */}
          <DetailSection title="学生基本信息">
            <div className="grid grid-cols-4 gap-y-3 text-[13px] text-gray-600 pl-2">
              <InfoItem label="姓名" value={record.name} />
              <InfoItem label="学号" value={record.studentId} />
              <InfoItem label="学院/专业" value={`${record.college} - ${record.major}`} />
              <InfoItem label="年级/班级" value={`${record.grade} - ${record.className}`} />
              <InfoItem label="学生类别" value={record.studentType} />
              <InfoItem label="学年" value={record.academicYear} />
              <InfoItem label="学期" value={record.semester} />
              <InfoItem label="测评指标所属单位" value={record.ownerUnit} />
            </div>
          </DetailSection>

          {/* 卡片2：综合测评指标加分项申请，只读展示 */}
          <DetailSection title="综合测评指标加分项申请">
            <ReadonlyBonusApplyTable
              student={student}
              record={record}
            />
          </DetailSection>

          {isAudit ? (
            <>
              {/* 审核页：流程审核卡片 */}
              <AuditNodeCard />

              {/* 审核页：流转历史卡片 */}
              <FlowHistoryCard />
            </>
          ) : (
            <>
              {/* 详情页：流转历史卡片 */}
              <FlowHistoryCard />
            </>
          )}
        </div>

        {isAudit && (
          <div className="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3 bg-white z-20 shrink-0">
            <button
              onClick={onClose}
              className="px-6 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-50 text-[14px] transition-colors font-medium"
            >
              取消
            </button>
            <button
              onClick={onClose}
              className="px-6 py-2 bg-[#1890ff] text-white rounded hover:bg-[#096dd9] text-[14px] shadow-sm transition-colors font-medium"
            >
              提交审核
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// 加分项申请只读表格：沿用“我的加分项申请”大表样式，材料名称加下划线展示。
function ReadonlyBonusApplyTable({ record }) {
  const formatLimit = (value) => (!value || value === '无') ? '-' : value;

  return (
    <div className="overflow-hidden w-full border border-gray-300 rounded-sm shadow-sm bg-white">
      <table className="w-full text-left text-[12px] border-collapse table-fixed min-w-full">
        <thead className="bg-[#f0f2f5] border-b border-gray-300 text-gray-700">
          <tr>
            <th className="border-r border-gray-300 px-1 py-2 font-bold text-center whitespace-nowrap w-[5%]">考核大类</th>
            <th className="border-r border-gray-300 px-1 py-2 font-bold text-center whitespace-nowrap w-[6%]">指标类型</th>
            <th className="border-r border-gray-300 px-2 py-2 font-bold text-center w-[11%]">一级指标</th>
            <th className="border-r border-gray-300 px-2 py-2 font-bold whitespace-nowrap w-[25%]">二级指标/细项</th>
            <th className="border-r border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight w-[3%] break-words">需要<br />材料</th>
            <th className="border-r border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight w-[3%] break-words">单次<br />得分</th>
            <th className="border-r border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight w-[3%] break-words">次数<br />限制</th>
            <th className="border-r border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight w-[3%] break-words">分数<br />限制</th>
            <th className="border-r border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight w-[3%] break-words">是否<br />参评</th>
            <th className="border-r border-gray-300 px-0.5 py-2 font-bold text-center text-[11px] leading-tight w-[3%] break-words">参评<br />个数</th>
            <th className="border-r border-gray-300 px-2 py-2 font-bold text-center w-[26%]">上传材料/填写说明</th>
            <th className="px-1 py-2 font-bold text-center whitespace-nowrap text-[#1890ff] w-[8%]">预计得分</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(indicatorDict).map(([categoryKey, category]) => {
            const rows = buildIndicatorApplyRows(category);
            const categoryExpectedTotal = rows.reduce((sum, item) => {
              const isMatched = record.projectName === item.name;

              if (!isMatched) {
                return sum;
              }

              const score = parseFloat(item.itemScore) * (record.selectedCount || 1);
              const limit = item.scoreLimit !== '-' ? parseFloat(item.scoreLimit) : Infinity;
              return sum + Math.min(score, limit);
            }, 0);

            return (
              <React.Fragment key={categoryKey}>
                {rows.map((item, index) => {
                  const isFirstOverall = index === 0;
                  const isMatched = record.projectName === item.name;

                  return (
                    <tr
                      key={`${categoryKey}-${item.bCatName}-${item.name}`}
                      className={`border-b border-gray-300 bg-white transition-colors ${isMatched ? 'bg-blue-50/20' : 'hover:bg-gray-50'}`}
                    >
                      {isFirstOverall && (
                        <td rowSpan={rows.length} className="border-r border-gray-300 text-center font-bold text-gray-700 bg-[#fafafa]">
                          {category.title}
                        </td>
                      )}

                      {isFirstOverall && (
                        <td rowSpan={rows.length} className="border-r border-gray-300 text-center text-gray-600 bg-[#fcfcfc]">
                          加分项
                          <br />
                          <span className="text-gray-400 text-[11px]">
                            (满分 {category.bonMax}分)
                          </span>
                        </td>
                      )}

                      {item.isFirstOfBCat && (
                        <td rowSpan={item.rowSpanForBCat} className="border-r border-gray-300 text-center text-gray-700 font-medium py-2 px-1.5 bg-gray-50/30 break-words">
                          {item.bCatName}
                        </td>
                      )}

                      <td className="border-r border-gray-300 px-2 py-2.5 text-gray-800 leading-snug break-words">
                        {item.name}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-600 px-0.5 break-words text-[11px]">
                        {item.needProof}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-600 px-0.5 font-bold break-words text-[11px]">
                        {item.itemScore}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-600 px-0.5 break-words text-[11px]">
                        {formatLimit(item.countLimit)}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-600 px-0.5 break-words text-[11px]">
                        {formatLimit(item.scoreLimit)}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-800 px-0.5 break-words text-[11px]">
                        {isMatched ? '是' : '-'}
                      </td>
                      <td className="border-r border-gray-300 text-center text-gray-800 px-0.5 break-words text-[11px]">
                        {isMatched ? record.selectedCount : '-'}
                      </td>
                      <td className="border-r border-gray-300 px-2 py-1.5 align-middle break-words">
                        {isMatched ? (
                          <span className="text-[#1890ff] underline cursor-pointer text-[12px]">
                            {record.materialName}
                          </span>
                        ) : (
                          <span className="text-gray-400 text-[11px] text-center block w-full">
                            -
                          </span>
                        )}
                      </td>

                      {isFirstOverall && (
                        <td rowSpan={rows.length} className="text-center font-bold text-[#1890ff] align-middle bg-blue-50/10 text-[15px]">
                          {categoryExpectedTotal}
                        </td>
                      )}
                    </tr>
                  );
                })}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// 审核节点卡片
function AuditNodeCard() {
  // ================= 审核表单状态 =================
  const [auditResult, setAuditResult] = useState('通过');
  const [auditOpinion, setAuditOpinion] = useState('同意加分，情况属实。');

  const handleAuditResultChange = (value) => {
    setAuditResult(value);
    setAuditOpinion(value === '通过' ? '同意加分，情况属实。' : '退回上一步');
  };

  return (
    <FlowSection title="流程审核">
      <div className="bg-[#f3f8ff] border border-[#91caff] rounded px-4 py-3 text-[13px] text-[#0958d9] leading-7 mb-7 flex items-start">
        <Info size={16} className="mr-2 mt-1 shrink-0" />
        <div>
          <div>
            <span className="font-bold">评议小组会审规则提示：</span>
            当前节点需评议小组
            <span className="text-[#ff7a00] font-bold mx-1">全体成员通过</span>
            方可流转至下一级。若任一成员选择
            <span className="text-red-500 font-bold mx-1">“退回上一步”</span>
            ，该申请将立刻终止流程并退回至学生端。
          </div>
          <div>
            当前小组会审进度：
            <span className="font-bold">2 / 3</span>
            人已完成审核。
          </div>
        </div>
      </div>

      <div className="text-[14px] text-gray-900 space-y-6">
        <div className="flex items-center">
          <span className="w-[96px] text-right mr-4 text-gray-700">审核处理：</span>
          <label className="flex items-center mr-7">
            <input
              type="radio"
              name="bonusAuditResult"
              checked={auditResult === '通过'}
              onChange={() => handleAuditResultChange('通过')}
              className="w-4 h-4 mr-2 accent-[#1890ff]"
            />
            通过
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="bonusAuditResult"
              checked={auditResult === '退回上一步'}
              onChange={() => handleAuditResultChange('退回上一步')}
              className="w-4 h-4 mr-2 accent-[#1890ff]"
            />
            退回上一步
          </label>
        </div>

        {auditResult === '通过' && (
          <div className="flex items-center">
            <span className="w-[96px] text-right mr-4 text-gray-700">下一步办理人：</span>
            <span className="text-gray-900 font-bold">
              辅导员（流转）
            </span>
          </div>
        )}

        <div className="flex items-start">
          <span className="w-[96px] text-right mr-4 text-gray-700 mt-2">审核意见：</span>
          <textarea
            value={auditOpinion}
            onChange={(event) => setAuditOpinion(event.target.value)}
            className="flex-1 h-[112px] border border-gray-300 rounded px-3 py-2 text-sm outline-none focus:border-[#1890ff] resize-none"
          />
        </div>
      </div>
    </FlowSection>
  );
}

// 流转历史卡片
function FlowHistoryCard() {
  const flowRows = [
    {
      index: 1,
      nodeName: '学生申请',
      handler: '陈红',
      handleTime: '2026-05-15 13:33:44',
      duration: '--',
      result: '--',
      opinion: '提交加分证明，请老师审核',
    },
    {
      index: 2,
      nodeName: '评议小组审核',
      handler: '王小明（已审）',
      handleTime: '2026-05-15 14:10:05',
      duration: '36分钟',
      result: '通过',
      opinion: '核对无误，同意',
    },
    {
      index: 3,
      nodeName: '评议小组审核',
      handler: '张莉（已审）',
      handleTime: '2026-05-15 15:22:10',
      duration: '1小时48分',
      result: '通过',
      opinion: '情况属实',
    },
  ];

  return (
    <FlowSection title="流转历史">
      <div className="border border-gray-200 rounded overflow-hidden">
        <table className="w-full text-left text-[13px] text-gray-700">
          <thead>
            <tr className="bg-[#fafafa] border-b border-gray-200">
              <th className="py-3 px-4 font-medium">序号</th>
              <th className="py-3 px-4 font-medium">环节名称</th>
              <th className="py-3 px-4 font-medium">办理人</th>
              <th className="py-3 px-4 font-medium">办理时间</th>
              <th className="py-3 px-4 font-medium">用时</th>
              <th className="py-3 px-4 font-medium">流程选择</th>
              <th className="py-3 px-4 font-medium">审核意见</th>
            </tr>
          </thead>
          <tbody>
            {flowRows.map((row, index) => (
              <tr key={index} className="border-b border-gray-100">
                <td className="py-3 px-4">{row.index}</td>
                <td className="py-3 px-4">{row.nodeName}</td>
                <td className="py-3 px-4">{row.handler}</td>
                <td className="py-3 px-4">{row.handleTime}</td>
                <td className="py-3 px-4">{row.duration}</td>
                <td className="py-3 px-4">
                  <span className={row.result === '通过' ? 'text-green-600 font-medium' : 'text-gray-500'}>
                    {row.result}
                  </span>
                </td>
                <td className="py-3 px-4">{row.opinion}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </FlowSection>
  );
}

// 流程类卡片：用于流程审核和流转历史，样式按截图做成紧凑白底卡片。
function FlowSection({ title, children }) {
  return (
    <div className="bg-white border border-gray-200 shadow-sm">
      <div className="h-[46px] px-6 border-b border-gray-100 flex items-center justify-between">
        <div className="text-[18px] font-bold text-gray-900 border-l-[3px] border-[#1890ff] pl-3">
          {title}
        </div>
        <ChevronUp size={18} className="text-[#1890ff]" />
      </div>
      <div className="p-6">
        {children}
      </div>
    </div>
  );
}

// 将指标配置转换为申请表行，并保留一级指标合并单元格需要的行数。
function buildIndicatorApplyRows(category) {
  return category.bonusCats.flatMap(bonusCategory => (
    bonusCategory.items.map((item, index) => ({
      bCatName: bonusCategory.name,
      isFirstOfBCat: index === 0,
      rowSpanForBCat: bonusCategory.items.length,
      ...item,
    }))
  ));
}

// 条件筛选：输入框
function FilterInput({ label, placeholder = '', type = 'text' }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-800 shrink-0 whitespace-nowrap">
        {label}：
      </span>
      <input
        type={type}
        placeholder={placeholder}
        className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:border-[#1890ff]"
      />
    </div>
  );
}

// 条件筛选：下拉框
function FilterSelect({ label }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-800 shrink-0 whitespace-nowrap">
        {label}：
      </span>
      <select className="border border-gray-300 rounded px-3 py-2 text-sm flex-1 min-w-0 outline-none focus:border-[#1890ff] bg-white text-gray-700">
        <option>全部</option>
      </select>
    </div>
  );
}

// 表格工具按钮
function TableToolbar() {
  return (
    <div className="flex items-center gap-4 text-gray-700">
      <button className="hover:text-[#1890ff]" title="刷新">
        <RefreshCw size={18} />
      </button>
      <button className="hover:text-[#1890ff]" title="密度">
        <SlidersHorizontal size={18} />
      </button>
      <button className="hover:text-[#1890ff]" title="设置">
        <Settings size={18} />
      </button>
    </div>
  );
}

// 简单分页：用于展示当前页、总条数、每页条数
function SimplePagination({ total }) {
  return (
    <div className="flex justify-end items-center mt-4 text-sm text-gray-700 gap-2">
      <span>
        第1-{total}条 / 共{total}条
      </span>
      <button className="text-gray-300 px-1">
        &lt;
      </button>
      <button className="px-2.5 py-1 border border-[#1890ff] text-[#1890ff] rounded">
        1
      </button>
      <button className="text-gray-300 px-1">
        &gt;
      </button>
      <select className="border border-gray-300 rounded px-2 py-1 outline-none bg-white">
        <option>10 条/页</option>
      </select>
    </div>
  );
}

// 详情抽屉分组卡片
function DetailSection({ title, children, collapsible = false }) {
  return (
    <div className="bg-white p-10">
      <div className="flex justify-between items-center mb-8">
        <div className="text-[18px] font-bold text-gray-900 border-l-[3px] border-[#1890ff] pl-3">
          {title}
        </div>
        {collapsible && (
          <ChevronDown size={18} className="text-[#1890ff]" />
        )}
      </div>
      {children}
    </div>
  );
}

// 详情抽屉信息项
function InfoItem({ label, value }) {
  return (
    <div>
      <span className="text-gray-400 w-28 inline-block">
        {label}：
      </span>
      <span className="text-gray-800">
        {value}
      </span>
    </div>
  );
}

// 表格表头
function TableHead({ children }) {
  return (
    <th className="py-3 px-4 font-medium text-gray-800">
      {children}
    </th>
  );
}

// 表格单元格
function TableCell({ children }) {
  return (
    <td className="py-3 px-4">
      {children}
    </td>
  );
}
